import { Component, OnInit, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
  public event: EventEmitter<any> = new EventEmitter();
  public properties: any = {};

  fileText: any = '';
  // fileText: any = "Choose file";

  isButtonDisabled: boolean = false;
  fileToUpload: File = null;
  fileWithFormData: FormData;
  returnFileData: any;
  errorMessage: string;

  constructor(private restService: RestService, private bsModalRef: BsModalRef) {}

  ngOnInit() {
    if (!this.properties) {
      this.properties = {
        maxSize: 20 * 1024 * 1024,
        allowedTypes: [
          'application/octet-stream',
          'image/bmp',
          'image/png',
          'image/svg+xml',
          'image/gif',
          'image/jpeg',
          'application/x-bzip',
          'application/x-bzip2',
          'text/csv',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-fontobject',
          'application/gzip',
          'application/json',
          'application/ld+json',
          'application/vnd.oasis.opendocument.presentation',
          'application/vnd.oasis.opendocument.spreadsheet',
          'application/vnd.oasis.opendocument.text',
          'application/pdf',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/rtf',
          'text/plain',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/zip',
          'application/x-7z-compressed',
          'audio/midi',
          'audio/x-midi',
          'audio/mpeg',
          'video/mpeg',
          'audio/aac',
        ],
      };
    }
  }

  handleFileInput(file) {
    var files: FileList = file;
    this.fileToUpload = files.item(0);
    this.fileText = this.fileToUpload.name;
    this.fileWithFormData = new FormData();
    this.fileWithFormData.set('file', this.fileToUpload, this.fileToUpload.name);
    // this.uploadFileToActivity();
  }

  uploadFileToActivity() {
    if (!this.fileToUpload) {
      this.errorMessage = 'Please select the file';
      return;
    }
    this.isButtonDisabled = true;
    if (this.validateFile(this.fileToUpload)) {
      this.restService.postFile('/api/files', this.fileWithFormData).subscribe(
        data => {
          this.isButtonDisabled = false;
          console.log(data);
          this.returnFileData = data;
          this.cancel();
        },
        error => {
          this.isButtonDisabled = false;
          console.log(error);
        },
      );
    } else {
      this.isButtonDisabled = false;
    }
  }

  cancel(): void {
    if (this.returnFileData) {
      this.event.emit(this.returnFileData);
    }
    this.bsModalRef.hide();
  }

  // frontend validation for file upload
  validateFile(file) {
    if (!this.properties.allowedTypes.includes(file.type)) {
      this.errorMessage = `File extension is not allowed`;
      return false;
    }
    if (file.size > this.properties.maxSize) {
      this.errorMessage = `File too large, file should be less than ${this.formatBytes(
        this.properties.maxSize,
        2,
      )}`;
      return false;
    }
    this.errorMessage = undefined;
    return true;
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: any, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
